import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'side-panel',
    imports: [CommonModule],
    templateUrl: './side-panel.component.html',
    styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent {
    @Input()
    public isVisible: boolean = false;

    @Input()
    public caption: string = 'Side Panel';

    @Output()
    public onDone = new EventEmitter();

    @Output()
    public onCancel = new EventEmitter();

    public triggerDone(): void {
        this.onDone.emit();
    }

    public triggerCancel(): void {
        this.onCancel.emit();
    }
}